function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var Svg029Configuration = function Svg029Configuration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4CAD9"
    },
    d: "M179.279,30.751c18.878,18.878,25.877,40.302,20.787,63.209l96.875,96.875L190.885,296.891  L94.01,200.016c-22.907,5.091-44.331-1.908-63.209-20.787C-0.591,147.837-8.865,99.687,10.227,59.811  c4.455-9.121,16.756-11.666,24.18-4.243l38.817,38.817c5.727,5.727,15.484,5.727,21.211,0c5.939-5.939,5.939-15.272,0-21.211  L55.617,34.357c-7.211-7.211-5.302-19.726,4.243-24.18C99.737-8.913,147.887-0.641,179.279,30.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8BFCC"
    },
    d: "M179.279,30.751c18.878,18.878,25.877,40.302,20.787,63.209l96.875,96.875l-53.028,53.028  L94.434,94.385c5.939-5.939,5.939-15.272,0-21.211L55.617,34.357c-7.211-7.211-5.302-19.726,4.243-24.18  C99.737-8.913,147.887-0.641,179.279,30.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4CAD9"
    },
    d: "M480.841,332.314c31.393,31.393,39.665,79.542,20.574,119.419  c-4.454,9.544-16.967,11.455-24.18,4.243l-38.817-38.817c-5.938-5.938-15.272-5.939-21.211,0c-5.727,5.727-5.938,15.273,0,21.211  l38.817,38.817c7.212,7.212,5.302,19.726-4.243,24.18c-14.424,6.787-29.695,10.182-44.967,10.182  c-27.575,0-54.302-10.606-74.453-30.756c-18.877-18.877-25.877-40.302-20.787-63.209l-99.481-99.481l106.056-106.056l99.481,99.481  C440.539,306.437,461.964,313.437,480.841,332.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8BFCC"
    },
    d: "M480.841,332.314c31.393,31.393,39.665,79.542,20.574,119.419  c-4.454,9.544-16.967,11.455-24.18,4.243l-38.817-38.817c-5.938-5.938-15.272-5.939-21.211,0L265.124,265.074l53.028-53.028  l99.481,99.481C440.539,306.437,461.964,313.437,480.841,332.314z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1A7B3"
    },
    d: "M254.518,275.68l95.45,95.45c5.856,5.856,15.355,5.856,21.211,0c5.856-5.856,5.856-15.355,0-21.211   l-95.45-95.45L254.518,275.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1A7B3"
    },
    d: "M254.518,233.258l-96.45-96.45c-5.856-5.856-15.355-5.856-21.211,0s-5.856,15.355,0,21.211   l96.45,96.45L254.518,233.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979CA7"
    },
    d: "M371.18,371.131c5.856-5.856,5.856-15.355,0-21.211l-95.45-95.45l-10.606,10.606L371.18,371.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979CA7"
    },
    d: "M254.518,233.258l-96.45-96.45c-5.856-5.856-15.355-5.856-21.211,0l107.056,107.056L254.518,233.258   z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F55C4A"
    },
    d: "M138.616,479.441l-10.606,10.606c-29.271,29.271-76.785,29.271-106.056,0  c-29.271-29.271-29.271-76.785,0-106.056l10.606-10.606h42.422l63.634,63.634V479.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E35043"
    },
    d: "M138.616,479.441l-10.606,10.606c-29.271,29.271-76.785,29.271-106.056,0l84.845-84.845  l31.817,31.817V479.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060"
    },
    d: "M479.571,93.518l-33.302,7l-34.787-34.787l7-33.302l72.754-31.181  c5.515-2.545,12.091-1.06,16.333,3.182c4.243,4.243,5.727,10.818,3.182,16.333L479.571,93.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53565C"
    },
    d: "M479.571,93.518l-33.302,7l-17.393-17.393l78.694-78.694c4.243,4.243,5.727,10.818,3.182,16.333  L479.571,93.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE33"
    },
    d: "M446.905,169.878l-44.119,2.97l-63.634-63.634l2.97-44.119c0,0,0.212-0.212,0.636-0.214  l75.724-32.453c6.787,12.728,14.636,24.817,25.454,35.635s22.907,18.666,35.635,25.454l-32.453,75.724  C447.117,169.666,446.905,169.878,446.905,169.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBC33"
    },
    d: "M446.905,169.878l-44.119,2.97l-31.817-31.817l72.966-72.966  c10.818,10.818,22.907,18.666,35.635,25.454l-32.453,75.724C447.117,169.666,446.905,169.878,446.905,169.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DB5FF"
    },
    d: "M443.936,174.121L202.25,415.807h-42.422l-63.634-63.634v-42.422L337.88,68.065  c1.273-1.273,2.758-2.333,4.243-2.969c6.575,24.392,19.089,47.512,38.18,66.602c19.091,19.09,42.21,31.604,66.602,38.18  C446.269,171.363,445.209,172.848,443.936,174.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D97FF"
    },
    d: "M443.936,174.121L202.25,415.807h-42.422L128.01,383.99l252.292-252.292  c19.09,19.09,42.21,31.604,66.602,38.18C446.269,171.363,445.209,172.848,443.936,174.121z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.405,
    y: 319.596,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 479.4305 590.5901)",
    style: {
      fill: "#E6EEFF"
    },
    width: 89.991,
    height: 149.984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.92,
    y: 383.617,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 543.4502 617.1215)",
    style: {
      fill: "#DAE2F2"
    },
    width: 89.991,
    height: 74.992
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg029Configuration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/029-configuration.34bc10d4.svg";
export { ForwardRef as ReactComponent };